import RateUpdate from "./RateUpdate";
export default RateUpdate;
